import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ModalUtils from 'utils/ModalUtils';
import { useQuery } from '@apollo/client';
import { FetchPolicy } from 'utils/enum/Core';
import CloseIcon from '@material-ui/icons/Close';
import History from 'components/widgets/History';
import NotesQuery from 'services/graphQL/query/NotesQuery';
import AccountingStyles from 'styles/modules/accounting/AccountingStyles';
import {
    makeStyles, Dialog, DialogContent, AppBar, Toolbar, Typography, IconButton,
} from '@material-ui/core';

const useStyle = makeStyles((theme) => AccountingStyles.checkActionList(theme));
const ownStyle = makeStyles(() => (
    {
        dialogContent: {
            height: '62vh',
            '& > div:first-child': {
                height: '62vh',
            },
            padding: 0,
            overflow: 'hidden',
        },
    }
));

const HistoryDialog = ({ id, onClose }) => {
    const {
        appBar, centerItems, title,
        dialogContent,
    } = {
        ...useStyle(),
        ...ownStyle(),
    };

    const [state, setState] = useState({ data: [] });
    const { data } = state;

    const { data: notesData, error, loading } = useQuery(NotesQuery.GET_BANKING_NOTES, {
        variables: { cbId: id },
        fetchPolicy: FetchPolicy.NETWORK_ONLY,
    });

    useEffect(() => {
        if (error) {
            ModalUtils.errorMessage(error?.graphQLErrors);
            return;
        }

        if (!loading && notesData?.getBankingNotes) {
            setState({ data: notesData.getBankingNotes });
        }
    }, [notesData, loading, error]);

    return (
        <>
            <Dialog
                open
                onClose={onClose}
                maxWidth="lg"
                fullWidth
                disableBackdropClick
                disableEscapeKeyDown
                scroll="paper"
            >
                <AppBar className={appBar}>
                    <Toolbar className={centerItems}>
                        <Typography variant="h6" className={title}>
                            History Notes
                        </Typography>
                        <div className={centerItems}>
                            <IconButton edge="start" color="inherit" onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>
                <DialogContent className={dialogContent}>
                    <History
                        loading={loading}
                        records={data ?? []}
                    />
                </DialogContent>
            </Dialog>
        </>
    );
};

HistoryDialog.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.func.isRequired,
};

HistoryDialog.defaultProps = {
    id: 0,
};

export default HistoryDialog;
